import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * React Router keeps the previous page's scroll position by default.
 * Reset to the top on every route change (honor in-page hash links).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1))
      // Allow the destination page to render before scrolling to the anchor
      const frame = window.requestAnimationFrame(() => {
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView()
          return
        }
        window.scrollTo(0, 0)
      })
      return () => window.cancelAnimationFrame(frame)
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

export default ScrollToTop
